import { render, staticRenderFns } from "./saveAsTemplateDialog.vue?vue&type=template&id=fa2178d0&scoped=true&lang=pug"
import script from "./saveAsTemplateDialog.vue?vue&type=script&lang=js"
export * from "./saveAsTemplateDialog.vue?vue&type=script&lang=js"
import style0 from "./saveAsTemplateDialog.vue?vue&type=style&index=0&id=fa2178d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2178d0",
  null
  
)

export default component.exports